<template>
  <div>
    
    <div class="page">
      
      <!-- <el-tooltip class="item" effect="dark" content="点击背景可更换背景图" placement="right">
        <div :style="coverImg" @click="imgchose" class="bgdiv"></div>
      </el-tooltip> -->
      <div :style="coverImg" class="bgdiv"></div>

      <div class="abdiv">
        <div class="fillimg">
          <my-upload ref="myUpload" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail" :modelValue.sync="show" :width="200" :height="200" img-format="png"
            :size="size" langType='zh' :noRotate='false' field="Avatar1" url="https://httpbin.org/post"></my-upload>
          <el-tooltip class="item" effect="dark" content="点击头像可更换头像" placement="right">
            <img @click="toggleShow" class="imgdiv" :src="imgDataUrl">
          </el-tooltip>
        </div>

        <div class="namediv">{{JSON.parse(this.baseUrl.getCookie("userInfo")).name}}</div>
        <div class="autographdiv">{{this.formdata.autograph}}</div>
      </div>


      <!-- <el-button @mouseover="mouseOver" v-if="imgchosehide" @click="imgchose" size="small" style="position:absolute;right: 10px;bottom: 10px;" type="primary" icon="el-icon-edit" circle></el-button> -->
    </div>
    <input type="file" ref="myimg" hidden="true" name="avatar" accept="image/gif,image/jpeg,image/jpg,image/png"
      @change="changeCoverImg($event)">
      
      <div class="page1">
        <div class="gundongdiv">
          <img style="width: 23px;height: 23px;margin-left: 10px;" src="../assets/horn.png" alt="">
          <div class="showtext">请输入您的收稿邮箱，获取验证码完成绑定。您可绑定多个收稿邮箱。当作者投稿给您所绑定的任一邮箱时，您可对稿件采取操作。</div>
        </div>
      <!-- 邮箱列表信息 -->
      <div class="topbar">
        <div style="width: 100px;font-weight: bold;font-size: 16px;">邮箱信息</div>
        <div style="display: flex;height: 1px;width: 100%;background-color: #e6e6e6;"></div>
        <div style="width: 32px;margin-left: 25px;">
          <!-- <el-button v-if="!tagdisable" size="medium" @click="addemail" round>添加邮箱</el-button> -->
          <el-button :loading="saveloading2" @click="saveemail" size="medium" type="primary" round>保存</el-button>
        </div>
      </div>
      <!-- <div v-if="emaildTags.length!=0 || tagdisable" style="margin-top: 10px;" class="topbar1"></div> -->
      <div style="margin-top: 10px;" class="topbar1">
        <div style="display: flex;width: 85%;flex-wrap: wrap;">
          <div :key="index" v-for="(item,index) in emaildTags" class="tagdiv">
            <div class="tagdivleft">{{item}}</div>
            <div class="tagdivright">
              <i @click="deleterow(index)" class="el-icon-close"></i>
            </div>
          </div>
          <!-- <div v-if="tagdisable" id="tagemail" style="width: 100%;display: flex;margin-top: 30px;"></div> -->
          <div id="tagemail" style="width: 100%;display: flex;margin-top: 30px;">
            <div style="width: 50%;border-bottom: 1px solid #e6e6e6;">
              <el-input v-model="tagemail" placeholder="请输入邮箱地址"></el-input>
            </div>
            <div class="codediv">
              <el-input style="width: 75%;" v-model="tagemailCode" placeholder="请输入验证码"></el-input>
              <div @click="getCode" :class="disabledbtn== false?'chose':'other'">{{btntext}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="topbarnodata" v-else>
        <img src="../assets/nodata1.png" alt="">
        <div style="margin-top: 20px;font-size: 13px;color: #aca8a8;">邮箱空空如也，快去绑定吧！</div>
      </div> -->


      <!-- 基本信息 -->
      <div class="topbar">
        <div style="width: 100px;font-weight: bold;font-size: 16px;">基本信息</div>
        <div style="display: flex;height: 1px;width: 100%;background-color: #e6e6e6;"></div>
        <div style="width: 32px;margin-left: 25px;">
          <el-button v-if="formdatadisable" size="medium" @click="editclick" round>修改</el-button>
          <el-button :loading="saveloading1" v-else @click="saveclick" size="medium" type="primary" round>保存</el-button>
        </div>

      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">
          <span style="color: red;">*</span>
          昵称：
        </div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.nickname" placeholder="请输入昵称">
          </el-input>
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">真实姓名：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.realname" placeholder="请输入真实姓名">
          </el-input>
        </div>
      </div>

      <div v-if="!formdatadisable" style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">
          <span style="color: red;">*</span>
          性别：
        </div>
        <div style="display: flex;height: 40px;width: 100%;align-items: center;">
          <el-radio style="margin-left: 15px;" :disabled="formdatadisable" v-model="formdata.gender" label="1">男
          </el-radio>
          <el-radio :disabled="formdatadisable" v-model="formdata.gender" label="2">女</el-radio>
        </div>
      </div>
      <div v-else style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">
          <span style="color: red;">*</span>
          性别：
        </div>
        <div style="display: flex;height: 40px;width: 100%;align-items: center;">
          <div style="margin-left: 15px;font-weight: bold;color: black;">
            <div v-if="formdata.gender==1">男</div>
            <div v-else-if="formdata.gender==2">女</div>
            <div v-else>空</div>
          </div>

        </div>
      </div>
      <!-- <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">生日：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-date-picker :disabled="formdatadisable" style="width: 600px;" v-model="formdata.birthday" type="date" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div> -->
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">简介：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.autograph" placeholder="请输入简介">
          </el-input>
        </div>
      </div>

      <!-- 联系信息 -->
      <div class="topbar">
        <div style="width: 100px;font-weight: bold;font-size: 16px;">联系信息</div>
        <div style="display: flex;height: 1px;width: 100%;background-color: #e6e6e6;"></div>
        <div style="width: 32px;margin-left: 25px;">

        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">通讯地址：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input style="width: 600px;" :disabled="formdatadisable" v-model="formdata.address" placeholder="请输入通讯地址">
          </el-input>
          <!-- <el-cascader v-model="address" :options="dataCity" :props="{ expandTrigger: 'hover' }" @change="handleChange">
          </el-cascader> -->
          <!-- <el-cascader :disabled="formdatadisable" clearable placeholder="请选择所在地" style="width: 600px;" v-model="formdata.address" :options="dataCity">
            <template slot-scope="{ node, data }">
              <span>{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader> -->
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">
          <span style="color: red;">*</span>
          手机号：
        </div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="true" style="width: 600px;" v-model="formdata.phone" placeholder="请输入手机号"></el-input>
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">微信：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.weixin" placeholder="请输入微信">
          </el-input>
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">QQ：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.qq" placeholder="请输入QQ">
          </el-input>
        </div>
      </div>

      <!-- 机构领域信息 -->
      <!-- <div>

      
      <div class="topbar">
        <div style="width: 100px;font-weight: bold;font-size: 16px;">机构领域</div>
        <div style="display: flex;height: 1px;width: 100%;background-color: #e6e6e6;"></div>
        <div style="width: 32px;margin-left: 25px;">

        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">所属机构：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.mechanism" placeholder="请输入昵称"></el-input>
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">所属领域：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.field" placeholder="请输入昵称"></el-input>
        </div>
      </div>
    </div> -->

      <!-- 职业信息 -->
      <!-- <div>
      <div class="topbar">
        <div style="width: 100px;font-weight: bold;font-size: 16px;">职业信息</div>
        <div style="display: flex;height: 1px;width: 100%;background-color: #e6e6e6;"></div>
        <div style="width: 32px;margin-left: 25px;">
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">公司：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.company" placeholder="请输入昵称"></el-input>
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">地区：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-cascader :disabled="formdatadisable" clearable placeholder="请选择所在地" style="width: 600px;" v-model="formdata.region" :options="dataCity">
            <template slot-scope="{ node, data }">
              <span>{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        
        </div>
      </div>
      <div style="margin-top: 10px;" class="topbar">
        <div style="width: 100px;font-size: 14px;text-align: right;">职位：</div>
        <div style="display: flex;height: 40px;width: 100%;">
          <el-input :disabled="formdatadisable" style="width: 600px;" v-model="formdata.zhiwu" placeholder="请输入真实姓名"></el-input>
        </div>
      </div>
    </div> -->
      <div style="width: 100%;height: 150px;"></div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import 'babel-polyfill'; // es6 shim
  import myUpload from 'vue-image-crop-upload';
  const dataCity = require('../assets/city.json')
  var countdown = 60;
  export default {
    data() {
      return {
        saveloading1: false,
        saveloading2: false,
        tagdisable: false,
        emaildTags: [],//邮箱列表
        dataCity: [],
        imgchosehide: false,
        formdata: {
          nickname: '',//昵称
          realname: '',//真实姓名
          address: '', //所在地
          gender: '1',//性别
          birthday: '',//生日
          autograph: '',//简介
          phone: '',//手机号
          email: '',//邮箱
          weixin: '',//微信
          qq: '',//qq
          mechanism: '',//机构
          field: '',//领域
          company: '',//公司
          region: '',//地区
          zhiwu: '',//职务
        },
        //是否禁用
        formdatadisable: true,
        imgDataUrl: "",
        show: false,
        size: 2.1,
        coverImg: "background-image: url(" + require('../assets/123.jpg') + ");",
        tagemail: '',//邮箱地址
        tagemailCode: '',//获取验证码
        codeEmail: '',//生成的验证码

        btntext: '获取验证码',
        disabledbtn: false,
      }
    },
    //注册组件
    components: {
      "my-upload": myUpload
    },
    //初始化方法
    mounted() {
      this.dataCity = dataCity;
      this.getuserInfo();
    },
    methods: {
      settime() {
        if (countdown == 0) {
          this.btntext = "获取验证码";
          this.disabledbtn = false;
          countdown = 60;
          return;
        } else {
          this.btntext = countdown + '秒后可重发';
          this.disabledbtn = true;
          countdown--;
        }
        setTimeout(() => {
          this.settime();
        }, 1000)
      },
      //根据id获取用户信息
      getuserInfo() {
        this.$showLoading();
        axios.get(this.baseUrl.hbjx + '/user/loadTByPrimaryKey', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            id: JSON.parse(this.baseUrl.getCookie("userInfo")).id,
          }
        })
          .then((res) => {
            var data = res.data;
            this.formdata.nickname = data.name == null ? '' : data.name;//昵称
            this.formdata.realname = data.realName == null ? '' : data.realName;//真实姓名
            this.formdata.gender = data.sex == null ? '' : data.sex;//性别
            this.formdata.birthday = data.birth == null ? '' : data.birth;//生日
            this.formdata.autograph = data.brief == null ? '' : data.brief;//简介
            this.formdata.address = data.addr == null ? '' : data.addr;//通讯地址
            this.formdata.phone = data.phone == null ? '' : data.phone;//手机号
            this.formdata.weixin = data.wxAccount == null ? '' : data.wxAccount;//微信
            this.formdata.qq = data.qqNumber == null ? '' : data.qqNumber;//QQ
            if (data.headProtraitUrl == null || data.headProtraitUrl == "") {
              this.imgDataUrl = "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png";
            } else {
              this.imgDataUrl = this.baseUrl.hbjx + "/" + data.headProtraitUrl;
            }
            if (data.email == null || data.email == "") {
              this.emaildTags = [];
            } else {
              this.emaildTags = data.email.split(",");
            }
            this.$closeLoading();
          })
          .catch(function (err) {
            console.log(err);
            this.$closeLoading();
          });
      },
      //获取验证码
      getCode() {
        if (!this.tagemail) {
          this.$Message.error('邮箱不能为空！');
          return;
        } else {
          //var reg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
          if (this.tagemail.indexOf('@') == -1) {
            this.$Message.error('邮箱格式不正确!');
            return;
          }
        }
        //获取验证码操作。。。。
        this.codeEmail = this.baseUrl.generateCode();
        let params = new FormData(); // 创建form对象
        params.append("to", this.tagemail); // 邮箱地址
        params.append("verifyCode", this.baseUrl.encode(this.codeEmail)); //验证码
        axios.post(this.baseUrl.hbjx + "/code/toMail", params).then((res) => {
          if (res.data == 'OK') {
            this.$Message.success('验证码已发送，请注意查收!');
            this.settime();
          }
        });
      },
      //添加邮箱信息
      addemail() {
        this.tagdisable = true;
      },
      //保存邮箱信息
      saveemail() {
        if (!this.tagemailCode) {
          this.$Message.error('验证码不能为空！');
          return;
        } else {
          if (this.tagemailCode == this.codeEmail) {
            this.saveloading2 = true;
            this.emaildTags.push(this.tagemail);
            let params = new FormData(); // 创建form对象
            params.append("id", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
            params.append("email", this.emaildTags.join(",")); //邮箱地址
            axios.post(this.baseUrl.hbjx + "/user/updTByPrimaryKey", params).then((res) => {
              if (res.data.code == "200") {
                // this.tagdisable = false;
                // this.tagemail = '',//邮箱地址
                // this.tagemailCode = '',//获取验证码
                // this.codeEmail = '',//生成的验证码
                // this.getuserInfo();
                this.saveloading2 = false;
                this.$Message.success('保存成功！');
                this.$router.go(0)
              } else {
                this.saveloading2 = false;
                this.$Message.error('保存失败！');
              }
            });
          } else {
            this.$Message.error('验证码不正确，请重新获取！');
            return;
          }
        }

      },
      deleterow(index) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: 'true'
        })
          .then(() => {
            this.emaildTags.splice(index, 1);
            let params = new FormData(); // 创建form对象
            params.append("id", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
            params.append("email", this.emaildTags.join(",")); //邮箱地址
            axios.post(this.baseUrl.hbjx + "/user/updTByPrimaryKey", params).then((res) => {
              if (res.data.code == "200") {
                this.getuserInfo();
                this.$Message.success('删除成功！');
              }
            });
          })
          .catch(() => { });

      },
      //编辑
      editclick() {
        this.formdatadisable = false;
      },
      //保存
      saveclick() {
        if (!this.formdata.nickname) {
          this.$Message.error('昵称不能为空！');
          return;
        }
        if (!this.formdata.gender) {
          this.$Message.error('性别不能为空！');
          return;
        }
        if (!this.formdata.phone) {
          this.$Message.error('手机号不能为空！');
          return;
        } else {
          if (this.formdata.phone.length != 11) {
            this.$Message.error('手机号格式不正确！');
            return;
          }
        }
        //验证通过保存数据
        this.saveData();
      },
      saveData() {
        this.saveloading1 = true;
        let params = new FormData(); // 创建form对象
        params.append("id", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
        params.append("name", this.formdata.nickname); //昵称
        params.append("realName", this.formdata.realname); //真实姓名
        params.append("sex", this.formdata.gender); //性别
        // params.append("birth", this.formdata.birthday!=""? new Date(this.formdata.birthday):null); //生日
        params.append("brief", this.formdata.autograph); //简介
        params.append("addr", this.formdata.address); //通讯地址
        params.append("wxAccount", this.formdata.weixin); //微信
        params.append("qqNumber", this.formdata.qq); //通讯地址
        axios.post(this.baseUrl.hbjx + "/user/updTByPrimaryKey", params).then((res) => {
          if (res.data.code == "200") {
            this.baseUrl.setCookie("userInfo", JSON.stringify(res.data.userInfo), 0.5);
            this.formdatadisable = true;
            //  this.getuserInfo();
            this.saveloading1 = false;
            this.$Message.success('保存成功！');
            this.$router.go(0)
          } else {
            this.saveloading1 = false;
            this.$Message.error('保存失败！');
          }
        });
      },
      toggleShow() {
        this.show = !this.show;
      },
      cropSuccess(imgDataUrl, field) {
        // console.log('-------- crop success --------', imgDataUrl, field);
      },
      //上传成功回调
      cropUploadSuccess(jsonData, field) {
        console.log('-------- upload success --------');
        this.imgDataUrl = jsonData.files.Avatar1;
        let params = new FormData(); // 创建form对象
        params.append("id", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
        params.append("base64", this.imgDataUrl); //图片
        params.append("type", "head"); //上传头像
        axios.post(this.baseUrl.hbjx + "/upload/updPictures", params).then((res) => {
          if (res.data.code == "200") {
            this.baseUrl.setCookie("userInfo", JSON.stringify(res.data.userInfo), 0.5);
            // this.getuserInfo();
            this.$refs.myUpload.off();
            this.$refs.myUpload.setStep(1)
            this.$Message.success('更换成功！');
            this.$router.go(0)
          }
        });

      },
      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      },
      base64ToBlob(base64Data) {
        let arr = base64Data.split(","),
          fileType = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          l = bstr.length,
          u8Arr = new Uint8Array(l);

        while (l--) {
          u8Arr[l] = bstr.charCodeAt(l);
        }
        return new Blob([u8Arr], {
          type: fileType
        });
      },
      blobToFile(newBlob, fileName) {
        newBlob.lastModifiedDate = new Date();
        newBlob.name = fileName;
        return newBlob;
      },
      //上传失败回调
      cropUploadFail(status, field) {
        console.log('-------- upload fail --------');
        console.log('上传失败状态' + status);
        console.log('field: ' + field);
      },
      //选择文件头像
      changeCoverImg: function (e) {
        var file = e.target.files[0]
        var reader = new FileReader()
        var that = this
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          // that.coverImg = this.result
          that.coverImg = "background-image: url(" + this.result + ");"

        }
      },
      //选择背景图片
      imgchose() {
        this.$refs.myimg.dispatchEvent(new MouseEvent('click'))
      },
      formatDate(date) {
        var date = new Date(date);
        var YY = date.getFullYear() + '';
        var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '';
        var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + '-' + MM + '-' + DD;
        // return YY + MM + DD +" "+hh + mm + ss;
      },
    }
  }
</script>
<style scoped>
  .gundongdiv{
    width: 1100px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fefbea;
  }
  .showtext{
    width: 870px;
    height: 35px;
    line-height: 35px;
    color: #dd722f;
    font-size: 14px;
    padding-left: 10px;
  }
  .el-icon-close {
    cursor: pointer;
  }

  .el-icon-close:hover {
    color: red;
    font-weight: bold;

  }

  .tagdiv {
    display: flex;
    width: 185px;
    height: 32px;
    line-height: 30px;
    font-size: 12px;
    color: #409EFF;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    background-color: #ecf5ff;
    border-color: #d9ecff;
    margin: 10px;
  }

  .tagdivleft {
    flex: 1;
    height: 100%;
    line-height: 30px;
    text-align: center;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tagdivright {
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /*css部分*/
  #image {
    padding-top: 200px;
  }

  .codediv {
    width: 45%;
    border-bottom: 1px solid #e6e6e6;
    margin-left: 20px;
    display: flex;
    position: relative;
    align-items: center;
  }

  table {
    border-top: 1px solid rgb(158, 156, 156);
    border-left: 1px solid rgb(158, 156, 156);
    border-collapse: collapse;
    /*设置单元格的边框合并为1*/
  }

  td {
    border-bottom: 1px solid rgb(158, 156, 156);
    border-right: 1px solid rgb(158, 156, 156);
    text-align: center;
  }

  .btn {

    background-color: indianred;
    padding: 7px 12px;
    color: white;
  }

  /deep/ .el-input__inner {
    font-weight: bold;
    border: none;
    border-bottom: 1px solid #e6e6e6;
  }

  #tagemail /deep/ .el-input__inner {
    border: none;
    font-weight: bold;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    font-weight: bold;
    background-color: #fff;
    border-color: #fff;
    color: black;
  }

  .row {
    width: 80%;
    height: 40px;
    display: flex;
    margin-top: 20px;
  }

  .rowleft {
    width: 83px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    font-size: 13px;

  }

  .rowright {
    height: 40px;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgb(158, 156, 156);
  }

  .topbar {
    width: 80%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }

  .topbar1 {
    width: 90%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: 20px;
  }

  .topbarnodata {
    width: 90%;
    height: 200px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    margin-left: 20px;
  }

  .fillimg {
    width: 105px;
    height: 105px;
    border-radius: 52.5px;
    background-color: rgb(255, 254, 254);
    display: flex;
    justify-content: center;
    align-items: center;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
  }

  .bgdiv {
    width: 100%;
    height: 300px;

    background-repeat: no-repeat;
    background-size: cover;
    filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    flex-direction: column;

  }

  .namediv {
    font-size: 24px;
    font-weight: bold;
    margin-top: 15px;
    color: white;
  }

  .autographdiv {
    font-size: 14px;
    color: white;
  }

  .abdiv {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    flex-direction: column;
    top: 0px;
    left: 0px;
    /* left: 466px; */
    cursor: pointer;
  }

  .imgdiv {
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }

  .page {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    margin: 5px 0px 0px 0px;
    background-color: #fff;
    /* -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%); */
    position: relative;
    overflow: hidden;
  }

  .page1 {

    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    margin: 5px 0px 10px 0px;
    background-color: #fff;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);

  }

  .other {
    position: absolute;
    top: 9px;
    right: 15px;
    font-weight: bold;
    color: rgb(198, 198, 198);
    pointer-events: none;
  }

  .chose {
    position: absolute;
    top: 9px;
    right: 15px;
    color: #6395f0;
    font-weight: bold;
    cursor: pointer;

  }
</style>


// WEBPACK FOOTER //
// src/components/MessagePage.vue